import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";

interface FunnelProgressProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
}

const FunnelProgress = ({ currentStep, totalSteps, className }: FunnelProgressProps) => {
  const { t } = useLanguage();
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className={cn("w-full max-w-2xl mx-auto mb-8", className)}>
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm text-muted-foreground">
          {t('funnel.progress.step')} {currentStep} {t('funnel.progress.of')} {totalSteps}
        </span>
        <span className="text-sm text-muted-foreground">
          {Math.round(progressPercentage)}% {t('funnel.progress.complete')}
        </span>
      </div>
      
      <div className="relative h-2 bg-muted rounded-full overflow-hidden">
        <div 
          className="absolute top-0 left-0 h-full bg-gradient-to-r from-primary to-accent rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progressPercentage}%` }}
        />
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse" />
      </div>
    </div>
  );
};

export default FunnelProgress;